import { Grid, GridItem } from '@calendly/ui/components/grid'

import { useWorkflowTemplatesList } from 'services/workflows/templates'

import { SmsDeactivatedPopup } from './modals'
import { TemplateTile } from './template_gallery/template_tile'
import { TileButton } from './template_gallery/template_tile/tile_button'

export const TemplatesList = ({ owner, templateIds, backTo, isEmptyState = false }) => {
  const templates = useWorkflowTemplatesList(templateIds)

  return (
    <>
      <Grid spacing={24} spacingMobile={16} data-component="grid-container">
        {
          templates.map((template) => (
            <GridItem size={4} sizeMobile={12} key={template.id}>
              <TemplateTile
                owner={owner}
                {...template}
                backTo={backTo}
                isEmptyState={isEmptyState}
              />
            </GridItem>
          ))
        }
      </Grid>
      <SmsDeactivatedPopup />
    </>
  )
}

export const DisabledTemplatesList = ({ templateIds }) => {
  const templates = useWorkflowTemplatesList(templateIds)

  return (
    <Grid spacing={24} spacingMobile={16} data-component="grid-container">
      {templates.map((template) => (
        <GridItem size={4} sizeMobile={12} key={template.id}>
          <TileButton key={template.id} {...template} disabled />
        </GridItem>
      ))}
    </Grid>
  )
}
